import { ChangeEvent, FC, FocusEvent, useState } from 'react';
import { TextField } from '@mui/material';
import { TextFieldProps, fieldToTextField } from 'formik-mui';
import { useTranslation } from 'mir-utils/i18n';
import { formatPhoneNumber } from 'mir-utils/utils/formatters';

type Props = {
  onValueChange: () => void;
};
/**
 * @summary Текстовое поле для номера телефона.
 */
export const PhoneNumberField: FC<TextFieldProps & Props> = ({ onValueChange, ...props }) => {
  const {
    form: { setFieldValue, getFieldMeta },
    field: { value, name, onBlur: onFieldBlur },
  } = props;

  const { t } = useTranslation();
  const [showInitialPlus, setShowInitialPlus] = useState<boolean>(false);

  return (
    <TextField
      label={t('Phone number')}
      size="small"
      variant="outlined"
      autoComplete="tel"
      {...props}
      {...fieldToTextField(props)}
      // ТЗ: при фокусе вместо пустого поля показываем "+". При блюре его убираем.
      value={showInitialPlus ? '+' : value}
      onFocus={(e: FocusEvent<HTMLInputElement>) => {
        const inputValue = e.target.value;
        setShowInitialPlus(inputValue === '' || inputValue === '+');
      }}
      onBlur={(e: FocusEvent<HTMLInputElement>) => {
        setShowInitialPlus(false);
        onFieldBlur(e); // Чтобы сработала валидация.
      }}
      onChange={(e: ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value;
        // Для необязательных полей перед форматированием меняем "+" на пустую строку.
        const formattedValue = formatPhoneNumber(newValue === '+' ? '' : newValue);
        const { touched } = getFieldMeta(name);

        setShowInitialPlus(formattedValue === ''); // Если пусто, также показываем "+".
        setFieldValue(name, formattedValue, touched); // Валидация на touched – после первого блюра поля.
        onValueChange();
      }}
    />
  );
};
